// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__2mmFn","lastUpdated":"PrivacyPolicy_lastUpdated__I83M1"};